export default {
  injectScript: '',
  injectFooter: '',
  debug: false,
  twitterButton: false,
  syncDelay: 0
}
